import _ from 'lodash';
import _axios from '../utils/axiosWrapper';

let clients = [];
let commands = [];
let logs = [];
let areClientsLoaded = false;
let areCommandsLoaded = false;
let areLogsLoaded = false;
/*
const testValues = {
    uptime: 2767131.5182985,
    freemem: 1177006080,
    cpus: [ 
        { 
            model: 'AMD A10-5750M APU with Radeon(tm) HD Graphics  ',
            speed: 2495,
            times: {
                user: 252020,
                nice: 0,
                sys: 30340,
                idle: 1070356870,
                irq: 0
            } 
        },
        {
            model: 'AMD A10-5750M APU with Radeon(tm) HD Graphics  ',
            speed: 2495,
            times: {
                user: 306960,
                nice: 0,
                sys: 26980,
                idle: 1071569080,
                irq: 0
            }
        },
        { 
            model: 'AMD A10-5750M APU with Radeon(tm) HD Graphics  ',
            speed: 2495,
            times: {
                user: 248450,
                nice: 0,
                sys: 21750,
                idle: 1070919370,
                irq: 0
            }
        },
        { 
            model: 'AMD A10-5750M APU with Radeon(tm) HD Graphics  ',
            speed: 2495,
            times: {
                user: 256880,
                nice: 0,
                sys: 19430,
                idle: 1070905480,
                irq: 20
            } 
        } 
    ],
    nic: { 
        'Conexión de área local 6': [ {
                address: '127.0.0.1',
                netmask: '255.0.0.0',
                family: 'IPv4',
                mac: '00:00:00:00:00:00',
                internal: true
            },
            {
                address: '::1',
                netmask: 'ffff:ffff:ffff:ffff:ffff:ffff:ffff:ffff',
                family: 'IPv6',
                mac: '00:00:00:00:00:00',
                internal: true
            } 
        ],
        'Conexión de área local 5': [ ],
        'Conexión de área local 4': [ ],
        'Conexión de área local': [ ],
        'Wi-Fi': [ ],
        'VirtualBox Host-Only Network #3': [ ],
        'Loopback Pseudo-Interface 1': [ ] 
    },
    controlValues: {
        platform: "win32",
        osrelease: "6.3.9600",
        ostype: "Windows_NT",
        arch: "x64",
        homedir: "C:\\Users\\Marlon",
        hostname: "BEAT-PC",
        curdir: "D:\\Projects_Js\\Sockets\\Slaves",
        totalmem: 7749353472,
        osname: "Windows 8.1"
    }
}

// Cambiantes: uptime, freemem


const bulkClients = [
    {
        clientID: 1,
        clientName: "DISTRIBUIDORA DE ALIMENTOS ALIMENTICIOS SAC",
        description: "Esta es una descripcion de la maquina. Podemos poner anotaciones aqui o contacto de alguien de sistemas. Aceptara sintaxis de tipo TODO y FIXME",
        labels: "WINTERS, JNJ, PROTISA",
        lastConnection: "2017-05-22 15:03:01",
        storedCommands: [
            {
                StoredCommandID: 1,
                target: "chainer.exe",
                arguments: "chain_dist1.xml",
                workingDirectory: "D:\\carpeta\\otraCarpeta",
                sendOutput: true
            },
            {
                StoredCommandID: 2,
                target: "chainer.exe",
                arguments: "chain_dist2.xml",
                workingDirectory: "D:\\carpeta\\otraCarpeta2",
                sendOutput: false
            }
        ],
        ...testValues        
    },
    {
        clientID: 2,
        clientName: "DISTRIBUICIONES LA PONDEROSA",
        description: "Esta es una descripcion de la maquina. Podemos poner anotaciones aqui o contacto de alguien de sistemas. Aceptara sintaxis de tipo TODO y FIXME",
        labels: "WINTERS, JNJ, PROTISA",
        lastConnection: "2017-05-22 15:03:01",
        storedCommands: [
            {
                StoredCommandID: 3,
                target: "chainer.exe",
                arguments: "chain_dist3.xml",
                workingDirectory: "D:\\carpeta\\otraCarpeta",
                sendOutput: true
            },
            {
                StoredCommandID: 4,
                target: "chainer.exe",
                arguments: "chain_dist4.xml",
                workingDirectory: "D:\\carpeta\\otraCarpeta2",
                sendOutput: false
            },
            {
                StoredCommandID: 4,
                target: "chainer.exe",
                arguments: "chain_dist5.xml",
                workingDirectory: "D:\\carpeta\\otraCarpeta2",
                sendOutput: false
            }

        ],
        ...testValues   
    },
    {
        clientID: 3,
        clientName: "DISTRIBUIDORA HEMET E HIJOS",
        description: "Esta es una descripcion de la maquina. Podemos poner anotaciones aqui o contacto de alguien de sistemas. Aceptara sintaxis de tipo TODO y FIXME",
        labels: "WINTERS, JNJ, PROTISA",
        lastConnection: "2017-05-22 15:03:01",
        storedCommands: [
            {
                StoredCommandID: 5,
                target: "chainer.exe",
                arguments: "chain_dist6.xml",
                workingDirectory: "D:\\carpeta\\otraCarpeta",
                sendOutput: true
            },
            {
                StoredCommandID: 6,
                target: "chainer.exe",
                arguments: "chain_dist7.xml",
                workingDirectory: "D:\\carpeta\\otraCarpeta2",
                sendOutput: false
            }
        ],
        ...testValues   
    },
    {
        clientID: 4,
        clientName: "CORPORACION DE GOLOSINAS SAC",
        description: "Esta es una descripcion de la maquina. Podemos poner anotaciones aqui o contacto de alguien de sistemas. Aceptara sintaxis de tipo TODO y FIXME",
        labels: "WINTERS, JNJ, PROTISA",
        lastConnection: "2017-05-22 15:03:01",
        storedCommands: [
            {
                StoredCommandID: 7,
                target: "chainer.exe",
                arguments: "chain_dist8.xml",
                workingDirectory: "D:\\carpeta\\otraCarpeta",
                sendOutput: true
            },
            {
                StoredCommandID: 8,
                target: "chainer.exe",
                arguments: "chain_dist9.xml",
                workingDirectory: "D:\\carpeta\\otraCarpeta2",
                sendOutput: false
            }
        ],
        ...testValues
    }
];
*/
export default {
    getClients(options) {
        /*
        options: {
            id: "",
            force: true/false,
            onSuccess: function(response)
        }
        */

        if(!areClientsLoaded || options.force === true) {
            /*
            window.setTimeout(() => {
                clients = bulkClients;
                areClientsLoaded = true;
                this.getClients({force: false, ..._.omit(options, ['force'])});
            }, 1 * 1000);
            */

            _axios.post('control/getClients.php')
			.then((response) => {
                if(response.data.status === "1") {
                    _.forEach(response.data.rows, (row) => {
                        _.forEach(row.storedCommands, (storedCommand) => {
                            storedCommand.arguments = storedCommand.arguments.replace(/\\\\/g, "\\");
                            storedCommand.target = storedCommand.target.replace(/\\\\/g, "\\");
                            storedCommand.workingDirectory = storedCommand.workingDirectory.replace(/\\\\/g, "\\");
                        }) 
                    });
                    clients = response.data.rows; // bulkClients;
                    ////console.warn("CLIENTS???: " + JSON.stringify(clients));
                    areClientsLoaded = true;
                    this.getClients({force: false, ..._.omit(options, ['force'])});
                }
			})
			.catch((error) => {
				options.onSuccess([]);
                console.log(error);
			});
            
        } else {
            if(options.id) {
                // FIXME: Ver si es seguro utilizar === en vez de solo ==
                // eslint-disable-next-line
                options.onSuccess(_.find(clients, (item) => { 
                    return item.clientID === options.id; }));
            } else {
                options.onSuccess(clients);
            }
        }
    },
    searchClientes(options) {
        /*
        options.query
        */
        return _.filter(clients, (item) => item.clientName.toUpperCase().indexOf(options.query.toUpperCase()) > -1 );
    },
    createClient(options) {
        /* 
            newClient: {
                clientName  : data.clientName,
                description : data.description,
                labels      : data.labels
            },
            onSuccess: (clients) => {
                this._refreshClients(clients);
                if(onSuccess) onSuccess();
            },
            onError: () => {

            }
        */
        console.log("createClients(): Se envio informacion para servicios. => " + JSON.stringify(options))

        _axios({
            method: "post",
            url: "control/createClient.php",
            data: {
                "clientName": options.newClient.clientName,
                "description": options.newClient.description,
                "labels": options.newClient.labels
            }
        })
        .then((response) => {
            if(response.data.status === "1") {
                // Capturar el id de response para la url?
                let temp_clients = clients;
                let newClientID = response.data.rows[0].clientID;
                clients.push({clientID: newClientID, ...options.newClient});;


                options.onSuccess(temp_clients);
            }
        })
        .catch((response) => {
            console.error(response);
        })
    },

    editClient(options) {
        _axios({
            method:'post',
            url:'control/updateClientFromID.php',
            data: {
                "clientID": options.client.clientID,
                "clientName": options.client.clientName,
                "description": options.client.description,
                "labels": options.client.labels
            }
        })
        .then((response) => {
            if(response.data.status === "1") {
                // BUSCAR AL CLIENTE DE LA INFO QUE SE HA CAMBIADO EN LA LISTA TOTAL
                // ACTUALIZAR SU INFORMACION Y CARGAR ESA INFORMACION DE NUEVO CON EL
                // METODO ONSUCCESS DE OPTIONS

                _.find(clients, (client) => {
                    if (client.clientID === options.client.clientID) {
                        client.clientID = options.client.clientID;
                        client.clientName = options.client.clientName;
                        client.description = options.client.description;
                        client.labels = options.client.labels;

                        return;
                    }
                });

                options.onSuccess(options.client);
            }
        })
        .catch((error) => {
            console.warn(error);
        });

    },

    updateClientStatus(options) {
        if (options.client.enabled) {
            _axios({
                method:'post',
                url:'control/disableClient.php',
                data: {
                    "clientID": options.client.clientID
                }
            })
            .then((response) => {
                if(response.data.status === "1") {
                    _.find(clients, (client) => {
                        return client.clientID === options.client.clientID;
                    }).enabled = "0";
                    options.onSuccess(false);
                }
            })
            .catch();
        } else {
            _axios({
                method:'post',
                url:'control/enableClient.php',
                data: {
                    "clientID": options.client.clientID
                }
            })
            .then((response) => {
                if(response.data.status === "1") {
                    _.find(clients, (client) => {
                        return client.clientID === options.client.clientID;
                    }).enabled = "1";
                    options.onSuccess(true);
                }
            })
            .catch();
        }
    },

    getCommands(options) {
        /*
        options: {
            id: "",
            force: true/false,
            onSuccess: function(response)
        }
        */

        if(!areCommandsLoaded || options.force === true) {
            _axios.post('control/getCommands.php')
            .then((response) => {
                if(response.data.status === "1") {
                    ////console.log("GET COMMANDS: " + JSON.stringify(response));

                    _.forEach(response.data.rows, (command) => {
                        command.commandArguments = command.commandArguments.replace(/\\\\/g, "\\");
                        command.commandTarget = command.commandTarget.replace(/\\\\/g, "\\");
                        command.workingDirectory = command.workingDirectory.replace(/\\\\/g, "\\");
                    });

                    commands = response.data.rows;
                    ////console.warn("COMMANDS???: " + JSON.stringify(commands));
                    areCommandsLoaded = true;
                    this.getCommands({force: false, ..._.omit(options, ['force'])});
                }
            })
            .catch((error) => {
                ////console.log("ERROR RESPONSE: " + error);
                // CAMBIAR?
                options.onSuccess([]);
            });

        } else {
            let commandList = [];
            if(options.id) {
                _.forEach(_.filter(commands, (item) => {
                    return item.clientID === options.id;
                }), (value) => {
                    commandList.push(value)
                });
                console.log("AQUI DEBERIA SER");
                
                options.onSuccess(commandList);
            } else {
                console.log("AQUI NO!");
                options.onSuccess(commands);
            }
        }
    },

    orderCommands() {
        commands = _.orderBy(commands, ["executed", "commandDate", "commandID"], ["asc", "desc", "desc"]);
    },
    
    getCommandLogs(options){
        //console.log("COMMANDLOGSS");

        if(!areLogsLoaded || options.force === true) {
            _axios.get('control/getCommandLogs.php')
            .then((response) => {
                if(response.data.status === "1") {
                    _.forEach(response.data.rows, (commandlog) => {
                        // Agregar reemplazos de caracteres de ser necesario
                        commandlog.commandOutput = commandlog.commandOutput.replace(/"/g, "");
                        commandlog.commandLogText = commandlog.commandLogText.replace(/"/g, "");
                    });

                    logs = response.data.rows;
                    areLogsLoaded = true;
                    this.getCommandLogs({force: false, ..._.omit(options, ['force'])});
                }
            })
            .catch((error) => {
                console.warn(error);
                options.onSuccess([]);
            });
        } else {
            let logList = [];
            if(options.id) {
                _.forEach(_.filter(logs, (item) => {
                    return item.clientID === options.id;
                }), (value) => {
                    logList.push(value);
                });
                options.onSuccess(logList);
            } else {
                options.onSuccess(logs);
            }
        }
    },
    /* sendCommands(options) {
        _.forEach(options, function(item) {
            this.createCommand(item);
        });
    }, */
    
    createCommand(options) {
        /* options = {
            command: {
                clientID        : "CLIENTID",
                target          : "TARGET",
                arguments       : "ARGUMENTS",
                workingDirectory: "WORKINGDIRECTORY"
            }
            /* onSuccess: (storedCommands) => {
                // this.setState({storedCommands: storedCommands});
                this._refreshCommands(storedCommands);
                if(onSuccess) onSuccess();
            }
            onError: () => {
                if(onError) onError();
            } //
        } */
        console.log("ITEM RECIBIDO: " + JSON.stringify(options));
        
        //console.log("OPTIONS SEND COMMANDs" + JSON.stringify(options)); 
        //console.log("OPTIONS SEND COMMANDs" + JSON.stringify(var1));

        _axios({
            method:'post',
            url:'control/createCommands.php',
            data: {
                "clientID": options.command.clientID,
                "commandTarget": options.command.commandTarget,
                "commandArguments": options.command.commandArguments,
                "workingDirectory": options.command.workingDirectory
            }
        })
        .then(function(response) {
            if(response.data.status === "1") {
                let newCommandID = response.data.rows[0].commandID;
                commands.push({commandID: newCommandID, ...options.command});
            }

        })
        .catch(function(response) {
            console.log("ERROR RESPONSE: " + response);
        }); 

    },

    createStoredCommand(options) {
        /*
            options: {
                newCommand: {}
                onSuccess: ()
                onError: ()
            }
        */
        _axios({
            method:'post',
            //url:'control/bridg-screateStoredCommands.php',
            url:'control/createStoredCommands.php',
            data: {
                "clientID": options.newCommand.clientID,
                "target": options.newCommand.target,
                "arguments": options.newCommand.arguments,
                "workingDirectory": options.newCommand.workingDirectory
            }
        })
        .then(function(response) {
            if(response.data.status === "1") {
                //console.log("RESPONSE: " + JSON.stringify(response));
                let temp_client = {};
                let newCommandID = response.data.rows[0].StoredCommandID; // (new Date()).getTime()
                for(let i =0; i<clients.length; i++) {
                    if(clients[i].clientID === options.newCommand.clientID) {
                        temp_client = clients[i];
                        clients[i].storedCommands.push({StoredCommandID: newCommandID, ...options.newCommand });
                        break;
                    }
                }
                options.onSuccess(temp_client.storedCommands);
            }
        })
        .catch(function(response) {
            console.log(response);
        });
            
    },

    deleteStoredCommand(options) {
        /*
            options: {
                command: {}
                onSuccess: ()
                onError: ()
            }
        */
        /* deleteCommandsFromID.php */
         _axios({
            method:'post',
            url:'control/deleteStoredCommandsFromID.php',
            data: {
                "StoredCommandID": options.command.StoredCommandID
            }
        })
        .then(function(response) {
            if(response.data.status === "1") {
                let client = {}
                for(let i =0; i<clients.length; i++) {
                    if(clients[i].clientID === options.command.clientID) {
                        client = clients[i];
                        clients[i].storedCommands = _.reject(clients[i].storedCommands, {StoredCommandID: options.command.StoredCommandID});
                        break;
                    }
                }

                options.onSuccess(client.storedCommands);
            }
        })
        .catch(function(response) {
            console.log(response);
        }); 



        
    },
    editStoredCommand(options) {
        /*
        options: {
            command: {
                clientID            : "",
                StoredCommandID     : "",
                target              : "",
                arguments           : "",
                workingDirectory    : ""
            }
            onSuccess: ()
            onError: ()
        }
        */

        _axios({
            method:'post',
            url:'control/updateStoredCommandFromID.php',
            data: {
                "clientID": options.command.clientID,
                "StoredCommandID": options.command.StoredCommandID,
                "target": options.command.target,
                "arguments": options.command.arguments,
                "workingDirectory": options.command.workingDirectory
            }
        })
        .then(function(response) {
            if(response.data.status === "1") {/* 
                console.log("RESPONSE" + JSON.stringify(response));
                console.log(response.data.rows[0].StoredCommandID); */
                let client = {};
                for(let i =0; i<clients.length; i++) {
                    if(clients[i].clientID === options.command.clientID) {
                        client = clients[i];
                        //clients[i].storedCommands.push({StoredCommandID: commandID, ...options.command });
                        for(let j = 0; j < client.storedCommands.length; j++) {
                            let sc = client.storedCommands[j];
                            // Cambiar por lodash.find()?
                            if(sc.StoredCommandID === options.command.StoredCommandID) {
                                sc.target              = options.command.target;
                                sc.arguments           = options.command.arguments;
                                sc.workingDirectory    = options.command.workingDirectory;
                                
                                clients[i].storedCommands[j] = sc;
                                break;
                            }
                        }
                        break;

                    }
                }
                options.onSuccess(client.storedCommands);
            }
        })
        .catch(function(response) {
            console.log(response);
        });

    }
}




// WEBPACK FOOTER //
// ./src/stores/clientsStore.js